    import './contents-slideshow.scss';
    

    import {register, load} from '@shopify/theme-sections';
    
    /**
     * Section: Featured Collection
     * ------------------------------------------------------------------------------
     * Large component displaying image galleries in a carousel.
     *
     * @namespace contentsSlideshow
     */
    
    import Carousel from '~/components/carousel';
    
    /**
     * DOM selectors.
     */
    const selectors = {
      id: 'contentsSlideshow',
      pagination: '[js-contents-slideshow="pagination"]',
      nextButton: '[js-contents-slideshow="nextButton"]',
      prevButton: '[js-contents-slideshow="prevButton"]',
    };
    
    /**
     * Instance globals.
     */
    let contentsSlideshow = {};
    
    /**
     * Featured Collection section constructor.
     * Executes on page load as well as Theme Editor `section:load` events.
     */
    register('contents-slideshow', {
    
      /**
       * Defaults.
       */
      getConfig() {
        return {
          swiper: {
            autoplay: this.getAutoplaySetting(),
            navigation: {
              nextEl: this.nextButton,
              prevEl: this.prevButton,
            },
            pagination: {
              el: this.pagination,
              type: 'progressbar',
              clickable: true,
            },
            loop: false,
            spaceBetween: 0,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            breakpoints: {
              1024: {
                allowTouchMove: this.getTouchMoveSetting(),
              }
            },
            lazy: true,
          }
        };
      },
    
      /**
       * Cache selectors.
       * - Define necessary variables and make available for component use.
       */
      cacheSelectors() {
        const container = `#${selectors.id}-${this.id}`;
        const pagination = `${container} ${selectors.pagination}`;
        const nextButton = `${container} ${selectors.nextButton}`;
        const prevButton = `${container} ${selectors.prevButton}`;
    
    
        this.cache = {
          container,
          pagination,
          nextButton,
          prevButton,
        };
      },
    
      /**
       * Set cached node selectors.
       */
      setNodeSelectors() {
        this.container = document.querySelector(this.cache.container);
        this.pagination = document.querySelector(this.cache.pagination);
        this.nextButton = document.querySelector(this.cache.nextButton);
        this.prevButton = document.querySelector(this.cache.prevButton);
      },
    
      /**
       * Fetches carousel autoplay setting
       * - Reads data-autoplay attribute on carousel container.
       * @returns {Boolean|Object} Autoplay setting object formatted for Swiper.
       */
      getAutoplaySetting() {
        const autoplay = Number(this.container.dataset.autoplay);
        if (!autoplay) { return false; }
    
        return {
          delay: autoplay,
        };
      },

      /**
       * Fetches carousel autoplay setting
       * - Reads data-autoplay attribute on carousel container.
       * @returns {Boolean|Object} Autoplay setting object formatted for Swiper.
       */
      getTouchMoveSetting() {
        const draggable = this.container.dataset.draggable;
      
        if (draggable != undefined) {
          return true;
        } else {
          return false;
        }
      },
      
      /**
       * Construct carousel.
       */
      constructCarousel() {
        if (!this.container) {
          throw new Error(`Could not find container of ${this.cache.container}`);
        }
    
        contentsSlideshow = Carousel(this.cache.container, this.getConfig());
        contentsSlideshow.init();
    
        this.swiperInstance = contentsSlideshow.getSwiperInstance();
      },
    
      /**
       * Event callback when Section is registered in scripts.
       */
      onLoad() {
        this.cacheSelectors();
        this.setNodeSelectors();
        this.constructCarousel();
      },
    
      /**
       * Event callback for Theme Editor `section:unload` event.
       */
      onUnload() {
        contentsSlideshow.resize();
      },
    
      /**
       * Event callback for Theme Editor `section:select` event.
       */
      onSelect() {
        contentsSlideshow.resize();
      },
    
      onBlockSelect(event) {
        this.swiperInstance.autoplay.stop();
    
        const slide = event.target;
        const slideId = slide.dataset.swiperSlideIndex;
        contentsSlideshow.select(slideId, 0);
      },
    
      onBlockDeselect() {
        this.swiperInstance.autoplay.start();
      },
    });
    
    load('contents-slideshow');
    